import { useIntl } from "react-intl";
import {
    ApiStatusContainer,
    CreateOrdersModalContainer,
    DraftOrderContainer,
    PlanningContainer,
    SiteAdminStatsGridsContainer,
    SizeOfQueuesContainer,
} from "../../containers";
import { Col } from "react-bootstrap";
import { OrderType } from "src/app/types/orders/order";

const AdminDashboard = () => {
    const { formatMessage } = useIntl();

    return (
        <div className="dashboardContainer">
            <Col sm={4}>
                <div className="d-flex flex-column gap-2">
                    <DraftOrderContainer />
                    <h2 className="mt-5">{formatMessage({ id: "dashboard.order.titleBulk" })}</h2>
                    <div className="d-flex gap-2">
                        <CreateOrdersModalContainer orderType={OrderType.FILLING} />
                        <CreateOrdersModalContainer orderType={OrderType.RANK} />
                        <CreateOrdersModalContainer orderType={OrderType.LEAD} />
                        <CreateOrdersModalContainer orderType={OrderType.DISC} />
                    </div>
                    <div className="pendingActions mt-5">
                        <PlanningContainer />
                        <h2 className="mt-5">{formatMessage({ id: "dashboard.status.title" })}</h2>
                        <ApiStatusContainer />
                        <h2 className="mt-5">{formatMessage({ id: "dashboard.queue.title" })}</h2>
                        <SizeOfQueuesContainer />
                    </div>
                </div>
            </Col>
            <Col sm={8}>
                <SiteAdminStatsGridsContainer />
            </Col>
        </div>
    );
};

export default AdminDashboard;
